// Module
var code = "<button class=\"btn btn-default fill button-widget\" ng-click=\"vm.execute()\" ng-disabled=\"vm.isEditMode\"> <i class=\"fa fa-fw\" ng-if=\"vm.item.configuration.hasIcon\" ng-class=\"vm.iconClass\"> </i> <span ng-if=\"vm.item.configuration.hasLabel\">{{vm.item.configuration.label}}</span> </button>";
// Exports
module.exports = code;